/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisciplineLangBatchViewModel } from "../types/ClassroomDisciplineLangBatchViewModel.ts";
import { upsertClassroomDisciplineLangViewModelSchema } from "./upsertClassroomDisciplineLangViewModelSchema.ts";

export const classroomDisciplineLangBatchViewModelSchema = z.object({
  items: z
    .array(z.lazy(() => upsertClassroomDisciplineLangViewModelSchema))
    .nullish(),
}) as unknown as ToZod<ClassroomDisciplineLangBatchViewModel>;
